import WidgetModule from "@eisinc/Overrides/Widgets/Basic/Slideshow";

export * from "@eisinc/Overrides/Widgets/Basic/Slideshow";

export default WidgetModule;
